import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faCheck, faChevronLeft, faChevronRight, faTriangleExclamation} from '@fortawesome/pro-solid-svg-icons';
import {BicButtonComponent, TooltipDirective} from '@buildinginformationcloud/bic-ui-components';
import {faChatbicAi} from '../../util/icons/custom-icons';
import {ProposalReviewService} from '../../../services/chat/proposal-review.service';

/**
 * Review-Leiste im Edit-Chat (#2789): zählt die offenen Änderungen eines chatBIC-Vorschlags im
 * gerade geöffneten Editor, springt per Stepper von Änderung zu Änderung und übernimmt bzw.
 * verwirft alle auf einmal. Der Zustand kommt vollständig aus dem {@link ProposalReviewService};
 * das Template liest nur dessen primitive Getter.
 */
@Component({
  selector: 'app-proposal-review-bar',
  standalone: true,
  templateUrl: './proposal-review-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent, BicButtonComponent, TooltipDirective],
})
export class ProposalReviewBarComponent {
  protected readonly review = inject(ProposalReviewService);

  protected readonly faChatbicAi = faChatbicAi;
  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faChevronRight = faChevronRight;
  protected readonly faCheck = faCheck;
  protected readonly faTriangleExclamation = faTriangleExclamation;
}
